import MField from './MField.vue';

MField.install = (app) => {
  app.component('MField', MField);
};

export { MField };
